import { z } from 'zod';
export const EvaluationTaskDescriptionSchema = z.object({
    expected: z.string(),
    setting: z.string(),
    testing: z.string(),
});
export const EvaluationGraderDescriptionSchema = z.discriminatedUnion('method', [
    z.object({ description: z.string(), method: z.literal('deterministic') }),
    z.object({ description: z.string(), method: z.literal('llmJudge'), model: z.string() }),
]);
export const EvaluationCheckSchema = z.object({
    grader: EvaluationGraderDescriptionSchema.optional(),
    name: z.string(),
    passed: z.boolean(),
    reason: z.string(),
});
//# sourceMappingURL=evaluationDescription.js.map